import React from 'react';
import { FieldTextInput } from '../../components';
import { validateURL, validateSocialMediaURL } from '../../util/validators';

const CustomFieldSocialMedia = props => {
  const { name, fieldConfig, defaultRequiredMessage, formId, intl, platform } = props;
  const { placeholderMessage, isRequired, requiredMessage } = fieldConfig?.saveConfig || {};
  const label = fieldConfig?.saveConfig?.label || fieldConfig?.showConfig?.label || fieldConfig?.label;

  const placeholder = placeholderMessage ||
    intl.formatMessage({
      id: `CustomExtendedDataField.placeholder${platform || 'Website'}URL`
    });

  const getValidationMessage = () => {
    if (platform) {
      return intl.formatMessage({
        id: `CustomExtendedDataField.notValid${platform}URL`,
      });
    }
    return intl.formatMessage({
      id: 'CustomExtendedDataField.notValidURL',
    });
  };

  const validate = value => {
    const requiredMsg = requiredMessage || defaultRequiredMessage;
    if (isRequired && (!value || value.trim() === '')) {
      return requiredMsg;
    }

    // Use platform-specific validation if platform is provided
    if (platform) {
      return validateSocialMediaURL(platform, getValidationMessage())(value);
    } else {
      return validateURL(getValidationMessage())(value);
    }
  };

  return (
    <FieldTextInput
      className={formId ? `${formId}.${name}` : name}
      id={formId ? `${formId}.${name}` : name}
      name={name}
      type="url"
      label={label}
      placeholder={placeholder}
      validate={validate}
    />
  );
};

export default CustomFieldSocialMedia;
